import { Badge } from "@similarweb/ui-components";
import { colorsPalettes } from "@similarweb/styles";
import { connect } from "react-redux";
import { i18nFilter } from "app/filters/i18nFilter";

const BetaBranchGreenBadgeComponent = ({ showBetaBranchData, text }) => {
    return (
        <>
            {showBetaBranchData && !showBetaBranchData.isUpdating && showBetaBranchData.value && (
                <Badge type="custom" bgColor={colorsPalettes.mint[400]}>
                    {i18nFilter()(text)}
                </Badge>
            )}
        </>
    );
};

const mapStateToProps = ({ common }) => {
    const { showBetaBranchData } = common;
    return {
        showBetaBranchData,
    };
};

export default connect(mapStateToProps, undefined)(BetaBranchGreenBadgeComponent);
